var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('AccumulationTable',{attrs:{"hourData":_vm.hourData,"fiftyMinData":_vm.fiftyMinData,"fiveMinData":_vm.fiveMinData,"dailyData":_vm.dailyData,"monthData":_vm.monthData,"totalLog":_vm.totalLog}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }